import * as Colors from 'material-ui/styles/colors';

export default {
  infoBarWrapper: {
    position: 'absolute',
    transform: 'translateY(-100%)',
    marginTop: '-4px',
    userSelect: 'none',
    boxSizing: 'border-box',
    height: '20px',
    width: 'auto',
    backgroundColor: 'rgba(117, 117, 117, 0.6)', // grey600
    color: 'rgba(255, 255, 255, 0.8)',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '12px',
    textTransform: 'uppercase',
    paddingLeft: '5px',
    paddingRight: '5px',
    display: 'flex',
    alignItems: 'center'
  },
  infoBarItem: {
    paddingRight: '15px',
    display: 'inline'
  },
  infoBarItemLabel: {
  },
  infoBarItemValue: {
    paddingLeft: '5px'
  }
};
